/* eslint-disable */
import { createRouter, createWebHashHistory } from "vue-router"
const routes = [
    {
        path: "/login",
        name: 'login',
        component: () => import('@/views/login.vue'),
        meta: {
            title: '登录',
            icon: '',
            code: "login",
        },
    }, 
    //**************** 知识库路由 ***********//
    {
        path: "/index",
        name: 'index',
        component: () => import('@/views/projects/index.vue'),
        meta: {
            title: '酷丁知识库',
            icon: '',
            code: "index",
        },
    }, 
    {
        path: "/",
        name: 'list',
        component: () =>
            import('@/views/projects/list.vue'),
        meta: {
            title: '项目列表',
            icon: '',
            code: "list",
        },
    },
    {
        path: "/search",
        name: 'search',
        component: () =>
            import('@/views/projects/search.vue'),
        meta: {
            title: '文档查询',
            icon: '',
            code: "search",
        },
    }, 
    {
        path: "/projects",
        name: 'projects',
        component: () => import('@/views/header.vue'),
        meta: {
            title: '酷丁知识库',
            icon: '',
            code: "projects",
        },
        children: [
            {
                path: '/',
                redirect: 'detail',
            },
            {
                path: "/detail",
                name: 'detail',
                component: () => import('@/views/projects/detail.vue'),
                meta: {
                    title: '文档详情',
                    icon: '',
                    code: "detail",
                },
            },
        ]
    },

    //**************** 业务文档路由 ***********//
    {
        path: "/home",
        name: 'home',
        component: () => import('@/views/process/home.vue'),
        meta: {
            title: '酷丁业务文档',
            icon: '',
            code: "index",
        },
    },
    {
        path: "/docList",
        name: 'docList',
        component: () =>
            import('@/views/process/docList.vue'),
        meta: {
            title: '业务列表',
            icon: '',
            code: "docList",
        },
    },
    {
        path: "/docSearch",
        name: 'docSearch',
        component: () =>
            import('@/views/process/docSearch.vue'),
        meta: {
            title: '业务文档查询',
            icon: '',
            code: "docSearch",
        },
    },
    {
        path: "/process",
        name: 'process',
        component: () => import('@/views/docHeader.vue'),
        meta: {
            title: '酷丁业务文档',
            icon: '',
            code: "process",
        },
        children: [
            {
                path: '/',
                redirect: 'docDetail',
            },
            {
                path: "/docDetail",
                name: 'docDetail',
                component: () => import('@/views/process/docDetail.vue'),
                meta: {
                    title: '业务文档详情',
                    icon: '',
                    code: "docDetail",
                },
            },
        ]
    },
]


export const router = createRouter({
    history: createWebHashHistory(),
    routes: routes
})
 
router.beforeEach((to, from, next) => {
    if (to.path == "/login" || to.path == "/index" || to.path == "/detail" || to.path == "/home" || to.path == "/docDetail") {
        next();
    } else {
        let token = localStorage.getItem('token');
        if (!token || token == '') {
            next({
                path: "/login"
            });
        } else {
            next();
        }
    }
});
export default router